module.exports = __webpack_public_path__ + "img/404.51b311f3.svg";